export default {
  // 表格列標題
  transactionHash: "交易哈希",
  sender: "發起方",
  receiver: "接收方",
  currency: "幣種",
  transactionAmount: "交易數量",
  transactionTime: "交易時間",

  // 加載和狀態
  loading: "拼命加載中",
  noData: "暫無數據",
  tooMuchData: "當前地址交易數據過度，僅支持輸入發送方/接收方地址的條件查詢",

  // 下載
  downloadDetails: "下載數據明細",
  downloadNote: "注：最多可下載10萬條數據",

  // 消息提示
  copySuccess: "複製成功",
};
